/* Serevue storefront — interactions. No dependencies. */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Toast ---------- */
  var toastTimer;
  function toast(message, opts) {
    var el = $('[data-sv-toast]');
    if (!el) return;
    opts = opts || {};
    el.innerHTML = '';
    var span = document.createElement('span');
    span.textContent = message;
    el.appendChild(span);
    if (opts.link) {
      var a = document.createElement('a');
      a.href = opts.link.href;
      a.textContent = opts.link.text;
      el.appendChild(a);
    }
    el.classList.toggle('is-error', !!opts.error);
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.hidden = true; }, 300);
    }, 3000);
  }

  /* ---------- Cart count ---------- */
  function updateCartCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-sv-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        document.dispatchEvent(new CustomEvent('sv:cart:updated', { detail: cart }));
        return cart;
      });
  }

  /* ---------- Add to cart (AJAX) ---------- */
  function initAtcForms() {
    $$('form[data-sv-atc-form]').forEach(function (form) {
      if (form.dataset.svBound) return;
      form.dataset.svBound = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = $('[data-sv-atc-button]', form);
        var errorEl = $('[data-sv-form-error]', form);
        if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
        if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }

        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
          .then(function (r) {
            return r.json().then(function (data) { return { ok: r.ok, data: data }; });
          })
          .then(function (res) {
            if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add to cart.');
            return updateCartCount().then(function () {
              // Where the cart drawer exists it opens and shows what was added, so a
              // toast on top of it would be two notifications for one action.
              if (document.querySelector('[data-sv-cart-drawer]')) {
                document.dispatchEvent(new CustomEvent('sv:cart:added'));
              } else {
                toast('Added to cart!', { link: { href: root + 'cart', text: 'View cart' } });
              }
            });
          })
          .catch(function (err) {
            if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
            toast(err.message, { error: true });
          })
          .finally(function () {
            if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
          });
      });
    });
  }

  /* ---------- Bundle / variant cards ---------- */
  function initVariantCards() {
    $$('[data-sv-bundles]').forEach(function (group) {
      if (group.dataset.svBound) return;
      group.dataset.svBound = '1';
      var sectionId = group.dataset.section;
      group.addEventListener('change', function (e) {
        var input = e.target;
        if (!input.matches('input[type="radio"]')) return;
        $$('.sv-bundle', group).forEach(function (card) {
          card.classList.toggle('is-selected', card.contains(input));
        });
        var price = input.dataset.price;
        var compare = input.dataset.compare;
        var available = input.dataset.available === 'true';
        $$('[data-sv-price="' + sectionId + '"]').forEach(function (el) {
          var sale = $('[data-sv-price-sale]', el);
          var cmp = $('[data-sv-price-compare]', el);
          var save = $('[data-sv-price-save]', el);
          if (sale) sale.textContent = price;
          if (cmp) { cmp.textContent = compare || ''; cmp.hidden = !compare; }
          if (save) { save.textContent = input.dataset.save || ''; save.hidden = !input.dataset.save; }
        });
        $$('[data-sv-sticky-price]').forEach(function (el) {
          if (el.dataset.section && el.dataset.section !== sectionId) return;
          el.innerHTML = '';
          el.appendChild(document.createTextNode(price));
          if (compare) {
            var s = document.createElement('s');
            s.textContent = compare;
            el.appendChild(s);
          }
        });
        var form = group.closest('form');
        var btn = form && $('[data-sv-atc-button]', form);
        if (btn) {
          btn.disabled = !available;
          var label = $('[data-sv-atc-label]', btn);
          if (label) label.textContent = available ? btn.dataset.labelAdd : btn.dataset.labelSoldout;
        }
        var url = new URL(window.location.href);
        if (group.dataset.updateUrl === 'true') {
          url.searchParams.set('variant', input.value);
          window.history.replaceState({}, '', url.toString());
        }
      });
    });
  }

  /* ---------- Quantity ---------- */
  function initQty() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sv-qty-step]');
      if (!btn) return;
      var input = btn.parentElement.querySelector('input');
      var step = parseInt(btn.dataset.svQtyStep, 10);
      var next = Math.max(parseInt(input.min || '1', 10), (parseInt(input.value, 10) || 1) + step);
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------- Gallery (swipe + dots + thumbs) ---------- */
  function initGalleries() {
    $$('[data-sv-gallery]').forEach(function (gallery) {
      if (gallery.dataset.svBound) return;
      gallery.dataset.svBound = '1';
      var track = $('[data-sv-track]', gallery);
      if (!track) return;
      var slides = $$('[data-sv-slide]', track);
      var dots = $$('[data-sv-dot]', gallery);
      var thumbs = $$('[data-sv-thumb]', gallery);

      function setActive(i) {
        dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
        thumbs.forEach(function (t, j) {
          t.setAttribute('aria-current', j === i ? 'true' : 'false');
          if (j !== i) return;
          var p = t.parentElement;
          // The rail is vertical on the product page and horizontal in the home
          // featured block, so follow whichever axis actually scrolls.
          if (p.scrollHeight > p.clientHeight) {
            var top = t.offsetTop - p.offsetTop;
            if (top < p.scrollTop || top + t.offsetHeight > p.scrollTop + p.clientHeight) {
              p.scrollTo({ top: top - 8, behavior: 'smooth' });
            }
          }
          if (p.scrollWidth > p.clientWidth) {
            var left = t.offsetLeft - p.offsetLeft;
            if (left < p.scrollLeft || left + t.offsetWidth > p.scrollLeft + p.clientWidth) {
              p.scrollTo({ left: left - 8, behavior: 'smooth' });
            }
          }
        });
      }
      function goTo(i) {
        var slide = slides[i];
        if (!slide) return;
        var left = slide.offsetLeft - track.offsetLeft;
        track.scrollTo({ left: left, behavior: 'smooth' });
        // A smooth scroll is abandoned by the browser if the track is re-laid out
        // mid-animation (lazy images settling, snap points recalculating), which
        // leaves the gallery showing the wrong slide. Confirm it landed, and jump
        // the rest of the way if it did not.
        window.setTimeout(function () {
          if (Math.abs(track.scrollLeft - left) > 4) track.scrollLeft = left;
        }, 420);
        setActive(i);
      }

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
              setActive(slides.indexOf(entry.target));
            }
          });
        }, { root: track, threshold: [0.6] });
        slides.forEach(function (s) { io.observe(s); });
      }

      dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
      gallery.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        var current = dots.length ? dots.findIndex(function (d) { return d.getAttribute('aria-current') === 'true'; }) : 0;
        goTo(Math.min(slides.length - 1, Math.max(0, current + (e.key === 'ArrowRight' ? 1 : -1))));
      });
    });
  }

  /* ---------- Accordions ---------- */
  function initAccordions() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sv-acc-btn]');
      if (!btn) return;
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      var group = btn.closest('[data-sv-acc-group]');
      if (!expanded && group && group.dataset.single === 'true') {
        $$('[data-sv-acc-btn][aria-expanded="true"]', group).forEach(function (other) {
          if (other !== btn) other.setAttribute('aria-expanded', 'false');
        });
      }
      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    });
  }

  /* ---------- Sticky cart bar ---------- */
  function initStickyBar() {
    var bar = $('[data-sv-sticky]');
    if (!bar || bar.dataset.svBound) return;
    bar.dataset.svBound = '1';
    var form = $('form[data-sv-atc-form]');
    var mainBtn = form && $('[data-sv-atc-button]', form);
    var stickyBtn = $('[data-sv-sticky-atc]', bar);
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (!form) { window.location.href = stickyBtn.dataset.href || root + 'cart'; return; }
        if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }
    if (!mainBtn || !('IntersectionObserver' in window)) return;
    var footer = $('.sv-footer');
    var mainVisible = true;
    var footerVisible = false;
    function update() {
      var show = !mainVisible && !footerVisible && mainBtn.getBoundingClientRect().top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
    }
    new IntersectionObserver(function (entries) {
      mainVisible = entries[0].isIntersecting;
      update();
    }).observe(mainBtn);
    if (footer) {
      new IntersectionObserver(function (entries) {
        footerVisible = entries[0].isIntersecting;
        update();
      }).observe(footer);
    }
  }

  /* ---------- Testimonial carousel ---------- */
  function initCarousels() {
    $$('[data-sv-carousel]').forEach(function (wrap) {
      if (wrap.dataset.svBound) return;
      wrap.dataset.svBound = '1';
      var track = $('[data-sv-carousel-track]', wrap);
      var cards = $$('[data-sv-carousel-card]', track);
      var dots = $$('[data-sv-dot]', wrap);
      var current = 0;
      function setActive(i) {
        current = i;
        dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i ? 'true' : 'false'); });
      }
      function goTo(i) {
        i = (i + cards.length) % cards.length;
        var left = cards[i].offsetLeft - track.offsetLeft;
        track.scrollTo({ left: left, behavior: 'smooth' });
        window.setTimeout(function () {
          if (Math.abs(track.scrollLeft - left) > 4) track.scrollLeft = left;
        }, 420);
        setActive(i);
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.6) setActive(cards.indexOf(entry.target));
          });
        }, { root: track, threshold: [0.6] });
        cards.forEach(function (c) { io.observe(c); });
      }
      dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });
      var prev = $('[data-sv-prev]', wrap);
      var next = $('[data-sv-next]', wrap);
      if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
      if (next) next.addEventListener('click', function () { goTo(current + 1); });
    });
  }

  /* ---------- Mobile menu (with focus trap) ---------- */
  function initMenu() {
    var drawer = $('[data-sv-drawer]');
    if (!drawer || drawer.dataset.svBound) return;
    drawer.dataset.svBound = '1';
    var openBtn = $('[data-sv-menu-open]');
    var overlay = $('[data-sv-drawer-overlay]');
    var lastFocus;
    function focusables() {
      return $$('a[href], button:not([disabled]), select, input, [tabindex]:not([tabindex="-1"])', drawer);
    }
    function open() {
      lastFocus = document.activeElement;
      requestAnimationFrame(function () {
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
        document.body.classList.add('sv-lock');
        var f = focusables();
        if (f.length) f[0].focus();
      });
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('sv-lock');
      if (lastFocus) lastFocus.focus();
    }
    if (openBtn) openBtn.addEventListener('click', open);
    $$('[data-sv-menu-close]', drawer).forEach(function (b) { b.addEventListener('click', close); });
    if (overlay) overlay.addEventListener('click', close);
    drawer.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ---------- Localization auto-submit ---------- */
  function initAutosubmit() {
    document.addEventListener('change', function (e) {
      if (e.target.matches('[data-sv-autosubmit]')) e.target.form.submit();
    });
  }

  function init() {
    initAtcForms();
    initVariantCards();
    initGalleries();
    initCarousels();
    initStickyBar();
    initMenu();
  }

  initQty();
  initAccordions();
  initAutosubmit();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Re-init when sections are edited in the Theme Editor */
  document.addEventListener('shopify:section:load', init);
})();
